// extracted by mini-css-extract-plugin
module.exports = {"container":"Jumbotron-module--container--1OCX_"};